// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/phone.svg';

export const Phone = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
